import GoBackButton from './GoBackButton.component';

export default GoBackButton;
